
const grey0 = '#ffffff';
const grey25 = '#fafafa';
const grey50 = '#f5f5f5';
const grey100 = '#eeeeee';
const grey200 = '#e7e7e7';
const grey250 = '#e3e6e6';
const grey300 = '#e0e0e0';
const grey400 = '#d8d8d8';
const grey500 = '#bdbdbd';
const grey600 = '#9e9e9e';
const grey700 = '#757575';
const grey800 = '#616161';
const grey900 = '#434343';
const grey950 = '#333333';
const grey975 = '#212121';
const grey1000 = '#000000';

const blue = '#0d74d1';
const blue50 = '#e1eef9';
const blue100 = '#bbdefb';
const blue500 = '#3391ff';
const blue700 = '#0d74d1';
const blue900 = '#0d47a1';
const blueAccent = '#00bdff';

const cyan = '#16b9df';
const cyan50 = '#e4f9f9';
const cyan100 = '#b6e3eb';
const cyan500 = '#16b9d4';
const cyan700 = '#0e94a6';
const cyan900 = '#0c7481';
const cyanAccent = '#18ffff';

const purple = '#3b44a9';
const purple50 = '#adb7dd';
const purple100 = '#6676bc';
const purple500 = '#3b44a9';
const purple700 = '#2e3187';
const purple900 = '#232968';
const purpleAccent = '#5a74f2';

const magenta = '#ec407a';
const magenta50 = '#fce0eb';
const magenta100 = '#f8bbd0';
const magenta500 = '#ec407a';
const magenta700 = '#c2185b';
const magenta900 = '#a5134e';
const magentaAccent = '#ff4081';

const orange = '#f57c00';
const orange50 = '#f8e1bb';
const orange100 = '#fdd179';
const orange500 = '#f57c00';
const orange700 = '#dd6105';
const orange900 = '#c15206';
const orangeAccent = '#ff6d00';

const red = '#f44336';
const red100 = '#ffcdd2';
const red700 = '#f44336';
const red900 = '#d32f2f';
const redAccent = '#ec515f';

const gold = '#ffeb3b';
const gold100 = '#fff9c4';
const gold700 = '#ffeb3b';
const gold900 = '#fbc02d';
const goldAccent = '#ffd600';

const green = '#4caf51';
const green100 = '#c8e6c9';
const green700 = '#4caf51';
const green900 = '#2e7d32';
const greenAccent = '#43b947';

const textcolordark = '#333333';
const textcolorlight = '#ffffff';

const action100 = 'const cyan100';
const action500 = 'const cyan500';
const action700 = 'const cyan700';
const action900 = 'const cyan900';

const order = Object.freeze([cyan, orange, magenta900, blue500, purple, orange700]);

const exported = {
  grey0,
  grey25,
  grey50,
  grey100,
  grey200,
  grey250,
  grey300,
  grey400,
  grey500,
  grey600,
  grey700,
  grey800,
  grey900,
  grey950,
  grey975,
  grey1000,

  blue,
  blue50,
  blue100,
  blue500,
  blue700,
  blue900,
  blueAccent,

  cyan,
  cyan50,
  cyan100,
  cyan500,
  cyan700,
  cyan900,
  cyanAccent,

  purple,
  purple50,
  purple100,
  purple500,
  purple700,
  purple900,
  purpleAccent,

  magenta,
  magenta50,
  magenta100,
  magenta500,
  magenta700,
  magenta900,
  magentaAccent,

  orange,
  orange50,
  orange100,
  orange500,
  orange700,
  orange900,
  orangeAccent,

  red,
  red100,
  red700,
  red900,
  redAccent,

  gold,
  gold100,
  gold700,
  gold900,
  goldAccent,

  green,
  green100,
  green700,
  green900,
  greenAccent,

  textcolordark,
  textcolorlight,

  action100,
  action500,
  action700,
  action900,

  order,
  other: orange100
};

export default exported;
export { grey0, grey25, grey50, grey100, grey200, grey250, grey300, grey400, grey500, grey600, grey700, grey800, grey900, grey950, grey975, grey1000, blue, blue50, blue100, blue500, blue700, blue900, blueAccent, cyan, cyan50, cyan100, cyan500, cyan700, cyan900, cyanAccent, purple, purple50, purple100, purple500, purple700, purple900, purpleAccent, magenta, magenta50, magenta100, magenta500, magenta700, magenta900, magentaAccent, orange, orange50, orange100, orange500, orange700, orange900, orangeAccent, red, red100, red700, red900, redAccent, gold, gold100, gold700, gold900, goldAccent, green, green100, green700, green900, greenAccent, textcolordark, textcolorlight, action100, action500, action700, action900, order, orange100 as other };
